import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'antd'
import { picProcess } from 'meinian-package/src/utils/image'
import logo from 'image/logo_icon.png'
import qs from 'qs'
import './index.less'

export default ({ data, query, style }: any) => {
  const history = useNavigate()
  const auth = data.loginUserInfo?.inspirationPermissions || []

  const jumpToDetail = () => {
    history(
      !auth.includes('FC03')
        ? `/home/coll/detail/${data.id}?${qs.stringify(query)}&inspirationId=${data.id}`
        : `/home/coll/detail/${data.id}?${qs.stringify(query)}&inspirationId=${data.id}&parentId=${data.parentId}&name=${
            data.name
          }`
    )
  }

  return (
    <div
      className="mn-child-inspiration-card"
      style={style}
      onClick={(e) => {
        e.preventDefault()
        jumpToDetail()
      }}
    >
      <img src={picProcess(data.lastBlogList?.[0]?.mainUrl) || logo} />
      <div className="mn-child-inspiration-card-info">
        <Tooltip title={data.name}>
          <div className="title">{data.name}</div>
        </Tooltip>
        <div className="info">
          <span>款式</span>
          <span style={{ color: 'var(--m-text-1)', marginLeft: '2px' }}>{data.blogNum}</span>
          <div className="line" />
          <div className="user">{data.userName}</div>
          创建
        </div>
      </div>
    </div>
  )
}
